import { useEffect } from 'react';

export function useViewportMeta(content = 'width=device-width, initial-scale=1') {
  useEffect(() => {
    const existing = document.querySelector('meta[name="viewport"]');
    const prev = existing?.getAttribute('content') ?? null;
    if (existing) {
      existing.setAttribute('content', content);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = content;
      document.head.appendChild(meta);
    }
    return () => {
      const el = document.querySelector('meta[name="viewport"]');
      if (!el) return;
      if (prev === null) el.remove();
      else el.setAttribute('content', prev);
    };
  }, [content]);
}
